window.axios = require('axios');
import hljs from 'highlight.js/lib/core';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

// Syntax highlighting
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('markdown', require('highlight.js/lib/languages/markdown'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));

document.querySelectorAll('pre code').forEach((block) => {
    hljs.highlightBlock(block);
});

if (document.querySelector('.splide')) {
    new Splide( '.splide', {
        perPage: 3,
        type: 'loop',
        autoplay: true,
        gap: "1rem",
        breakpoints: {
            1023: {
              perPage: 2,
            },
            767: {
                perPage: 1
            }
      }
    }).mount();
}

const languagePickers = document.querySelectorAll('.js-language-selector');
const languageDropdowns = document.querySelectorAll('.js-language-options');

if (languagePickers && languageDropdowns) {
    const handleLanguagePopup = () => {

        Array.from(languageDropdowns).map(dropdown => {
            const isOpen = dropdown.classList.contains('block');
    
            if (isOpen) {
                dropdown.classList.add('hidden');
                dropdown.classList.remove('block');
            } else {
                dropdown.classList.remove('hidden');
                dropdown.classList.add('block');
            }
        })
    };

    Array.from(languagePickers).map(languagePicker => 
        languagePicker.addEventListener('click', handleLanguagePopup)
    );    
}


const hobbyRevealers = [...document.querySelectorAll('[data-hobby-revealer]')];

if (hobbyRevealers) {
    hobbyRevealers.forEach(revealer => {
        let timeoutIds = []; // Array to store timeout IDs

        const showAllImages = () => {
            [...revealer.children].forEach((img, index) => {
                if (index > 0) {
                    const timeoutId = setTimeout(() => {
                        img.classList.add('opacity-100');
                        img.classList.remove('opacity-0');
                    }, (index) * 400);
                    timeoutIds.push(timeoutId); // Store the timeout ID
                }
            });
        }

        // Function to hide all images except the first one
        const hideAllImages = () => {
            timeoutIds.forEach(id => {
                clearTimeout(id); // Clear all timeouts
            });

            [...revealer.children].forEach((img, index) => {
                if (index > 0) {
                    img.classList.add('opacity-0');
                    img.classList.remove('opacity-100');
                }
            });
        }

        // Add mouseenter and mouseleave event listeners
        revealer.addEventListener("mouseenter", showAllImages);
        revealer.addEventListener("mouseleave", hideAllImages);

        // Initially hide all images except the first one
        hideAllImages();
    });
}
